import { useEffect } from "@wordpress/element";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { getSettings } from "admin/store/storeSlice";
import Loading from "./Loading";
import ConnectAccount from "./ConnectAccount";
import Disconnect from "./Disconnect";

const Account = () => {
	const dispatch = useDispatch();
	const store = useSelector(({ admin }) => admin.store);
	const { isSettingsLoaded, isCorksyAccountConnected } = store;

	useEffect(() => {
		dispatch(getSettings());
	}, [dispatch]);

	return (
		<div className="flex flex-col">
			<div className="pb-16 flex items-center">
				<Typography className="h2 mx-12 font-medium" color="textSecondary">
					Corksy Account
				</Typography>
			</div>
			{isSettingsLoaded && !isCorksyAccountConnected && (
				<ConnectAccount store={store} />
			)}
			{!isSettingsLoaded && <Loading />}

			{isCorksyAccountConnected && <Disconnect />}
		</div>
	);
};

export default Account;
